/**
 * Persistent per-browser-profile device id.
 *
 * Sent as the X-Device-Id header on login so the backend can scope its
 * one-session-per-device policy to an actual client install instead of the
 * User-Agent string, which is identical for every install of the same
 * browser+OS and otherwise causes unrelated sessions to revoke each other.
 *
 * Stored in localStorage (shared across tabs/reloads of this origin) and
 * generated once on first use.
 */
const STORAGE_KEY = "deviceId";

export const DEVICE_ID_HEADER = "X-Device-Id";

const generateId = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export const getDeviceId = (): string => {
  if (typeof window === "undefined" || !window.localStorage) {
    return generateId();
  }

  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;

  const id = generateId();
  window.localStorage.setItem(STORAGE_KEY, id);
  return id;
};
